import { z } from 'zod';

export const generalQuerySchema = z
  .object({
    name: z.string().min(1, 'Name is required'),
    email: z.string().min(1, 'Email is required').email('Invalid email address'),
    query: z.string().min(1, 'Query is required'),
    propertyAddress: z.string().optional(),
    queryDetails: z.string().min(1, 'Query details are required'),
  })
  .refine(
    (data) => {
      if (data.query === 'property_listing') {
        return !!data.propertyAddress?.trim();
      }
      return true;
    },
    { message: 'Please select a property for this query.', path: ['propertyAddress'] },
  );

export type GeneralQueryFormData = z.infer<typeof generalQuerySchema>;
